module.exports = __webpack_public_path__ + "img/SEJ_Eventos_copiar.41602fca.svg";